// Иконка чата — два пузыря, левый больше. Используется для FAB,
// пункта сайдбара «Связаться с разрабом» и в админке.
import React from "react";

export function ChatBubbleLeftRightIcon({ size = 24, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke={color} strokeWidth="1.8"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7c0-1.7 1.3-3 3-3h9c1.7 0 3 1.3 3 3v5c0 1.7-1.3 3-3 3h-1l-3 3v-3H6c-1.7 0-3-1.3-3-3V7z" />
      <path d="M7.5 8.5h6M7.5 11.5h4" />
      <path d="M18 9.5h2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2h-1l-2 2v-2" />
    </svg>
  );
}

export default ChatBubbleLeftRightIcon;
